export const EMAIL_SUPPORT = "hello@pafyll.com" as const;
export const FACEBOOK_PIXEL_ID = 2807237916097667 as const;
export const SNAPCHAT_PIXEL_ID =
  "aadf0287-78a2-4e84-8176-6b8c168c6e7d" as const;
export const CURRENCY_OFFSET = 100;

export const BASE_SHIPPING_PRICE = 3900;

export const VAT_RATE = 25;

export const FREE_SHIPPING_ITEM_COUNT = 2;
// free shipping for  orders over 29500
export const FREE_SHIPPING_THRESHOLD = 29500;

export const API_BASE = "/api";
// If server side request direct from BE
// if client side go through FE proxy
export const API_URL =
  typeof window === "undefined" ? process.env.NEXT_PUBLIC_BACKEND_URL : "";

export const PUBLIC_URL = process.env.NEXT_PUBLIC_URL
  ? process.env.NEXT_PUBLIC_URL
  : `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`;

export const ACCEPT_COOKIES_COOKIE_NAME = "acceptCookies";
export const LOCALE_COOKIE_NAME = "NEXT_LOCALE";

export const APPLICATION_JSON_HEADER = {
  "Content-Type": "application/json",
};

const { BACKEND_CLIENT_USERNAME, BACKEND_CLIENT_PASSWORD } = process.env;
export const FRONTEND_AUTH_HEADER_VALUE = `Basic ${Buffer.from(
  `${BACKEND_CLIENT_USERNAME}:${BACKEND_CLIENT_PASSWORD}`
).toString("base64")}`;

export const LOG_TO_SLACK_STORAGE_KEY = "logToSlack";
export const SEND_CODE_STORAGE_KEY = "sendCode";

export const CART_IS_OPEN_QUERY_PARAM = "cartIsOpen";
export const INVITATION_CODE_QUERY_PARAM = "invitation_code";

export const NEWSLETTER_BANNER_SEEN = "newsletterSeen";

export const UNLEASH_SESSION_COOKIE = "UNLEASH_SESSION_ID";
export const UNLEASH_SEGMENT_COOKIE = "UNLEASH_SEGMENT";

export const UNLEASH_API_PROXY_DEFINITIONS = "/api/proxy-definitions";

/**
 * This is a list of product sku codes that we only want to make available to business account holders
 * KKS0 === KKS900 (new sku)
 * BSL0 === BSL1800 (new sku)
 */
export const SKU_CODES_FOR_BUSINESS_ACCOUNTS = [
  "KKS0",
  "KKS900",
  "BSL0",
  "BSL1800",
];
